import "../../Assets/Styles/Header.css";
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Dropdown} from "react-bootstrap";
import {HashLink} from "react-router-hash-link";
import {useTranslation} from "react-i18next";

export default function Header() {
    const {i18n} = useTranslation();

    const [matches, setMatches] = useState(
        window.matchMedia("(max-width: 1100px)").matches
    );
    const [lang, setLang] = useState(null);

    useEffect(() => {
        window
            .matchMedia("(max-width: 1100px)")
            .addEventListener('change', e => setMatches(e.matches));

    });

    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
        localStorage.setItem("lang", lng);
    };

    console.log(lang)

    return (
        <div className="header-menu">
            <div className="header-logo">
                <img className="header-logo-img" alt="logo"
                     src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065562/FunRecycle/Logo-min_fcl7gr.svg"
                />
                <p>FUN recycle</p>
            </div>
            {!matches ?
                (
                    <nav className="header-nav" style={{gap: "20px"}}>
                        <Link to="/">{i18n.t('Home')}</Link>
                        <HashLink smooth to="/#about">{i18n.t('About')}</HashLink>
                        <HashLink smooth to="/#features">{i18n.t('Features')}</HashLink>
                        <HashLink smooth to="/#reviews">{i18n.t('Reviews')}</HashLink>
                        <HashLink smooth to="/#download" className="download-btn">{i18n.t('Download App')}</HashLink>
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic" className="dropdown-text">
                                {i18n.language}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => {
                                        changeLanguage("en");
                                        setLang("en");
                                    }}
                                >
                                    ENG
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => {
                                        changeLanguage("ua");
                                        setLang("ua");
                                    }}
                                >
                                    UA
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </nav>
                )
                :
                (
                    <div className="dropdown-container">
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic" className="dropdown-menu-logo">
                                <img alt="dropdown-img"
                                     src="https://res.cloudinary.com/dvjdkgzbe/image/upload/v1679065565/FunRecycle/Vector-min_domrpx.svg"
                                />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href="/">{i18n.t('Home')}</Dropdown.Item>
                                <Dropdown.Item>
                                    <HashLink smooth to="/#about">{i18n.t('About')}</HashLink>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <HashLink smooth to="/#features">{i18n.t('Features')}</HashLink>
                                </Dropdown.Item>
                                <Dropdown.Item>
                                    <HashLink smooth to="/#reviews">{i18n.t('Reviews')}</HashLink>
                                </Dropdown.Item>
                                <Dropdown.Item className="dropdown-download-btn">
                                    <HashLink smooth to="/#download" className="download-btn">{i18n.t('Download App')}</HashLink>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic" className="dropdown-text">{i18n.language.toString().toUpperCase()}</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setLang("ENG")}>EN</Dropdown.Item>
                                <Dropdown.Item onClick={() => setLang("UA")}>UA</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}
        </div>
    );
}